
(function(){
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
  var desk = window.matchMedia('(min-width: 1024px)');
  function hdrH(){ return parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--hdr')) || 72; }
  function inView(el, cb, opts){
    if (!('IntersectionObserver' in window)){ cb(true); return; }
    new IntersectionObserver(function(es){ es.forEach(function(e){ cb(e.isIntersecting, e); }); }, opts || {}).observe(el);
  }

  /* ---- Jour en cours (heure de Paris) : horaires surlignés ---- */
  function parisDay(){
    try { var d = new Intl.DateTimeFormat('en-GB', {timeZone:'Europe/Paris', weekday:'short'}).format(new Date()); return {Sun:0,Mon:1,Tue:2,Wed:3,Thu:4,Fri:5,Sat:6}[d]; }
    catch(e){ return new Date().getDay(); }
  }
  var today = parisDay();
  [].forEach.call(document.querySelectorAll('.wk-days li[data-day]'), function(li){ if (+li.dataset.day === today) li.classList.add('today'); });
  [].forEach.call(document.querySelectorAll('.hours tr[data-day]'), function(tr){
    if (+tr.dataset.day === today){ tr.classList.add('today'); var t = document.querySelector('[data-today]'); if (t) t.textContent = tr.querySelector('td').textContent; }
  });

  /* ---- Copier l'adresse ---- */
  [].forEach.call(document.querySelectorAll('[data-copy]'), function(b){
    b.addEventListener('click', function(){
      var txt = b.dataset.copy, lab = b.querySelector('span');
      function ok(){ b.classList.add('done'); lab.textContent = 'Adresse copiée'; setTimeout(function(){ b.classList.remove('done'); lab.textContent = "Copier l'adresse"; }, 2200); }
      if (navigator.clipboard && navigator.clipboard.writeText){ navigator.clipboard.writeText(txt).then(ok, function(){ lab.textContent = txt; }); }
      else { lab.textContent = txt; }
    });
  });

  /* ---- Hero : « DOUAI » dessiné en relief (profondeur qui suit la souris), supportrice, damier ---- */
  var GLYPHS = {"letters":[{"adv":0.9535,"contours":[[[0.4747,0.0],[0.131,0.0],[0.1074,0.002],[0.0902,0.0083],[0.0788,0.0195],[0.0724,0.0362],[0.0704,0.0592],[0.0704,0.9408],[0.0724,0.9638],[0.0788,0.9805],[0.0902,0.9918],[0.1074,0.998],[0.131,1.0],[0.4747,1.0],[0.5087,0.9992],[0.5414,0.9969],[0.5729,0.993],[0.603,0.9876],[0.6318,0.9808],[0.6593,0.9725],[0.6854,0.9627],[0.7101,0.9516],[0.7334,0.9391],[0.7553,0.9253],[0.7758,0.9101],[0.7949,0.8937],[0.8125,0.876],[0.8287,0.857],[0.8434,0.8369],[0.8566,0.8155],[0.8683,0.7931],[0.8785,0.7694],[0.8872,0.7447],[0.8943,0.719],[0.8998,0.6921],[0.9038,0.6643],[0.9062,0.6354],[0.907,0.6056],[0.907,0.3944],[0.9062,0.3644],[0.9038,0.3354],[0.8998,0.3075],[0.8943,0.2806],[0.8872,0.2547],[0.8785,0.2299],[0.8683,0.2063],[0.8566,0.1838],[0.8434,0.1625],[0.8287,0.1424],[0.8125,0.1235],[0.7949,0.1058],[0.7758,0.0894],[0.7553,0.0743],[0.7334,0.0605],[0.7101,0.0481],[0.6854,0.037],[0.6593,0.0273],[0.6318,0.0191],[0.603,0.0123],[0.5729,0.0069],[0.5414,0.0031],[0.5087,0.0008]],[[0.6282,0.3986],[0.6282,0.6014],[0.6274,0.6221],[0.6251,0.6413],[0.6212,0.6591],[0.6157,0.6753],[0.6086,0.69],[0.5998,0.7033],[0.5893,0.715],[0.577,0.7251],[0.5629,0.7338],[0.5471,0.7409],[0.5294,0.7464],[0.5098,0.7503],[0.4883,0.7527],[0.4648,0.7535],[0.3493,0.7535],[0.3493,0.2465],[0.4648,0.2465],[0.4883,0.2473],[0.5098,0.2497],[0.5294,0.2536],[0.5471,0.2591],[0.5629,0.2662],[0.577,0.2749],[0.5893,0.285],[0.5998,0.2967],[0.6086,0.31],[0.6157,0.3247],[0.6212,0.3409],[0.6251,0.3587],[0.6274,0.3779]]]},{"adv":0.9606,"contours":[[[0.0465,0.3732],[0.0465,0.6268],[0.0473,0.6567],[0.0497,0.6857],[0.0537,0.7137],[0.0592,0.7406],[0.0664,0.7664],[0.075,0.7912],[0.0853,0.8148],[0.097,0.8373],[0.1102,0.8586],[0.1249,0.8788],[0.1411,0.8976],[0.1588,0.9153],[0.1779,0.9317],[0.1985,0.9468],[0.2205,0.9606],[0.2439,0.973],[0.2687,0.9841],[0.2949,0.9938],[0.3224,1.002],[0.3513,1.0088],[0.3816,1.0142],[0.4132,1.018],[0.4461,1.0204],[0.4803,1.0211],[0.5143,1.0204],[0.5471,1.018],[0.5785,1.0142],[0.6087,1.0088],[0.6374,1.002],[0.6649,0.9938],[0.691,0.9841],[0.7157,0.973],[0.739,0.9606],[0.761,0.9468],[0.7814,0.9317],[0.8005,0.9153],[0.8182,0.8976],[0.8343,0.8788],[0.849,0.8586],[0.8622,0.8373],[0.8739,0.8148],[0.8841,0.7912],[0.8928,0.7664],[0.8999,0.7406],[0.9055,0.7137],[0.9095,0.6857],[0.9119,0.6567],[0.9127,0.6268],[0.9127,0.3732],[0.9119,0.3433],[0.9095,0.3143],[0.9055,0.2863],[0.8999,0.2594],[0.8928,0.2336],[0.8841,0.2088],[0.8739,0.1852],[0.8622,0.1627],[0.849,0.1414],[0.8343,0.1212],[0.8182,0.1023],[0.8005,0.0847],[0.7814,0.0683],[0.761,0.0532],[0.739,0.0394],[0.7157,0.027],[0.691,0.0159],[0.6649,0.0062],[0.6374,-0.002],[0.6087,-0.0088],[0.5785,-0.0142],[0.5471,-0.018],[0.5143,-0.0204],[0.4803,-0.0211],[0.4461,-0.0204],[0.4132,-0.018],[0.3816,-0.0142],[0.3513,-0.0088],[0.3224,-0.002],[0.2949,0.0062],[0.2687,0.0159],[0.2439,0.027],[0.2205,0.0394],[0.1985,0.0532],[0.1779,0.0683],[0.1588,0.0847],[0.1411,0.1023],[0.1249,0.1212],[0.1102,0.1414],[0.097,0.1627],[0.0853,0.1852],[0.075,0.2088],[0.0664,0.2336],[0.0592,0.2594],[0.0537,0.2863],[0.0497,0.3143],[0.0473,0.3433]],[[0.6338,0.3606],[0.6338,0.6394],[0.6328,0.6592],[0.6299,0.6774],[0.625,0.6941],[0.6182,0.7092],[0.6097,0.7228],[0.5993,0.7349],[0.5872,0.7454],[0.5734,0.7543],[0.5579,0.7616],[0.5409,0.7673],[0.5222,0.7714],[0.502,0.7738],[0.4803,0.7746],[0.4583,0.7738],[0.4378,0.7714],[0.4189,0.7673],[0.4017,0.7616],[0.3861,0.7543],[0.3722,0.7454],[0.36,0.7349],[0.3496,0.7228],[0.3409,0.7092],[0.3342,0.6941],[0.3293,0.6774],[0.3263,0.6592],[0.3253,0.6394],[0.3253,0.3606],[0.3263,0.3408],[0.3293,0.3226],[0.3342,0.3059],[0.3409,0.2908],[0.3496,0.2772],[0.36,0.2651],[0.3722,0.2546],[0.3861,0.2457],[0.4017,0.2384],[0.4189,0.2327],[0.4378,0.2286],[0.4583,0.2262],[0.4803,0.2253],[0.502,0.2262],[0.5222,0.2286],[0.5409,0.2327],[0.5579,0.2384],[0.5734,0.2457],[0.5872,0.2546],[0.5993,0.2651],[0.6097,0.2772],[0.6182,0.2908],[0.625,0.3059],[0.6299,0.3226],[0.6328,0.3408]]]},{"adv":0.9746,"contours":[[[0.3422,0.6451],[0.3422,0.0592],[0.3403,0.0362],[0.3339,0.0195],[0.3225,0.0083],[0.3053,0.002],[0.2817,0.0],[0.1225,0.0],[0.0991,0.002],[0.0822,0.0083],[0.0712,0.0195],[0.0652,0.0362],[0.0634,0.0592],[0.0634,0.6324],[0.0641,0.6615],[0.0664,0.6897],[0.0702,0.717],[0.0755,0.7433],[0.0823,0.7687],[0.0906,0.793],[0.1004,0.8162],[0.1116,0.8383],[0.1244,0.8594],[0.1386,0.8793],[0.1542,0.898],[0.1713,0.9155],[0.1898,0.9318],[0.2098,0.9468],[0.2313,0.9605],[0.2541,0.9729],[0.2784,0.984],[0.304,0.9937],[0.3311,1.0019],[0.3596,1.0088],[0.3894,1.0141],[0.4207,1.018],[0.4533,1.0203],[0.4873,1.0211],[0.5215,1.0203],[0.5543,1.018],[0.5857,1.0141],[0.6157,1.0088],[0.6442,1.0019],[0.6714,0.9937],[0.6972,0.984],[0.7215,0.9729],[0.7445,0.9605],[0.7659,0.9468],[0.786,0.9318],[0.8046,0.9155],[0.8217,0.898],[0.8374,0.8793],[0.8516,0.8594],[0.8644,0.8383],[0.8756,0.8162],[0.8854,0.793],[0.8937,0.7687],[0.9005,0.7433],[0.9058,0.717],[0.9096,0.6897],[0.9119,0.6615],[0.9127,0.6324],[0.9127,0.0592],[0.9107,0.0362],[0.9043,0.0195],[0.8929,0.0083],[0.8757,0.002],[0.8521,0.0],[0.693,0.0],[0.6695,0.002],[0.6527,0.0083],[0.6417,0.0195],[0.6356,0.0362],[0.6338,0.0592],[0.6338,0.6451],[0.6328,0.6651],[0.6297,0.6835],[0.6246,0.7004],[0.6174,0.7156],[0.6082,0.7292],[0.597,0.741],[0.5838,0.7511],[0.5685,0.7595],[0.5512,0.7661],[0.5319,0.7708],[0.5106,0.7737],[0.4873,0.7746],[0.4641,0.7737],[0.4428,0.7708],[0.4237,0.7661],[0.4065,0.7595],[0.3914,0.7511],[0.3784,0.741],[0.3673,0.7292],[0.3583,0.7156],[0.3513,0.7004],[0.3463,0.6835],[0.3432,0.6651]]]},{"adv":0.969,"contours":[[[0.9634,0.9423],[0.638,0.0465],[0.6289,0.0276],[0.6179,0.0143],[0.6042,0.0058],[0.5867,0.0013],[0.5648,0.0],[0.4042,0.0],[0.3823,0.0012],[0.3649,0.0056],[0.3511,0.0143],[0.3401,0.0285],[0.331,0.0493],[0.007,0.9423],[0.0014,0.9629],[0.0018,0.979],[0.0088,0.9906],[0.023,0.9977],[0.0451,1.0],[0.193,1.0],[0.2201,0.999],[0.2417,0.9959],[0.2586,0.9905],[0.2716,0.9825],[0.2816,0.9717],[0.2893,0.9579],[0.2958,0.9408],[0.3282,0.8394],[0.6324,0.8394],[0.6648,0.9408],[0.6703,0.9579],[0.6778,0.9717],[0.688,0.9825],[0.7016,0.9905],[0.7194,0.9959],[0.7421,0.999],[0.7704,1.0],[0.9225,1.0],[0.9444,0.9977],[0.9592,0.9906],[0.9673,0.979],[0.9686,0.9629]],[[0.5169,0.4535],[0.569,0.6183],[0.393,0.6183],[0.4451,0.4521],[0.4527,0.4237],[0.4587,0.3955],[0.4633,0.3682],[0.4667,0.3424],[0.469,0.3188],[0.4705,0.2981],[0.4714,0.2808],[0.4718,0.2676],[0.4718,0.2593],[0.4718,0.2563],[0.4859,0.2563],[0.486,0.2593],[0.4864,0.2676],[0.4873,0.2808],[0.4887,0.2982],[0.4909,0.319],[0.4938,0.3427],[0.4978,0.3687],[0.5029,0.3962],[0.5092,0.4247]]]},{"adv":0.4211,"contours":[[[0.0704,0.0563],[0.0704,0.9437],[0.0722,0.9657],[0.0781,0.9818],[0.0887,0.9923],[0.1047,0.9982],[0.1268,1.0],[0.293,1.0],[0.315,0.9982],[0.331,0.9923],[0.3416,0.9818],[0.3475,0.9657],[0.3493,0.9437],[0.3493,0.0563],[0.3475,0.0343],[0.3416,0.0182],[0.331,0.0077],[0.315,0.0018],[0.293,0.0],[0.1268,0.0],[0.1047,0.0018],[0.0887,0.0077],[0.0781,0.0182],[0.0722,0.0343]]]}]};
  /* Mot en relief dessiné : contour rouge non rempli, profondeur hachurée qui suit la souris.
     Formes : contours Panton 900 aplatis (hauteur de capitale = 1). */
  function Word3D(canvas, data, o){
    o = o || {};
    var ctx = canvas.getContext('2d'), red = o.color || '#DF0036';
    var track = o.track == null ? 0.05 : o.track;
    var L = [], x = 0, minX = 1e9, maxX = -1e9;
    function area(c){ var s = 0; for (var i = 0; i < c.length; i++){ var a = c[i], b = c[(i + 1) % c.length]; s += a[0] * b[1] - b[0] * a[1]; } return s / 2; }
    function rnd(s){ s = Math.sin(s * 127.1 + 311.7) * 43758.5453; return s - Math.floor(s); }
    data.letters.forEach(function(g, li){
      // contour extérieur dans le sens positif, creux (D, O, A…) dans le sens inverse : l'orientation relative de la police est gardée
      var cs = g.contours.map(function(c){ return c.map(function(q){ return [q[0] + x, q[1]]; }); });
      var big = cs.reduce(function(m, c){ return Math.abs(area(c)) > Math.abs(area(m)) ? c : m; }, cs[0]);
      if (area(big) < 0) cs.forEach(function(c){ c.reverse(); });
      cs.forEach(function(p){ p.forEach(function(q){ minX = Math.min(minX, q[0]); maxX = Math.max(maxX, q[0]); }); });
      L.push({cs: cs}); x += g.adv + track;
    });
    // décalage pour que le mot commence à 0
    L.forEach(function(l){ l.cs.forEach(function(c){ c.forEach(function(q){ q[0] -= minX; }); }); });
    var W = maxX - minX;
    // échantillons de hachure (fixes) et arêtes vives
    var lightDir = [0.6, -0.8];
    L.forEach(function(l, li){
      l.samples = []; l.corners = []; l.len = [];
      l.cs.forEach(function(c, ci){
        var n = c.length, nrm = [], seg = [], per = 0;
        for (var i = 0; i < n; i++){
          var a = c[i], b = c[(i + 1) % n], dx = b[0] - a[0], dy = b[1] - a[1], d = Math.hypot(dx, dy) || 1e-9;
          nrm.push([dy / d, -dx / d]); seg.push(d); per += d;
        }
        l.len.push(per);
        var ink = 0.37 + rnd(li * 7 + ci);
        for (var i = 0; i < n; i++){
          var a = c[i], b = c[(i + 1) % n], nn = nrm[i];
          var shade = 0.5 - 0.5 * (nn[0] * lightDir[0] + nn[1] * lightDir[1]);
          var sp = 0.085 - 0.06 * shade;           // espacement : faces à l'ombre plus serrées
          var t = 0;
          while (true){
            var need = (1 - ink) * sp;
            if (t + need > seg[i]){ ink += (seg[i] - t) / sp; break; }
            t += need; ink = 0;
            var f = t / seg[i], k = l.samples.length + li * 1000;
            l.samples.push({p: [a[0] + (b[0] - a[0]) * f, a[1] + (b[1] - a[1]) * f], n: nn,
              j0: 0.04 + rnd(k) * 0.1, j1: 0.02 + rnd(k + .5) * 0.12, al: 0.62 + rnd(k + .25) * 0.38, d: rnd(k + .75)});
          }
        }
        // arêtes : virage fort sur une courte distance (coins arrondis compris)
        var i = 0;
        while (i < n){
          var turn = function(k){ var p = nrm[(k - 1 + n) % n], q = nrm[k]; return Math.atan2(p[0] * q[1] - p[1] * q[0], p[0] * q[0] + p[1] * q[1]); };
          var tk = turn(i);
          if (Math.abs(tk) > 0.04){
            var j = i, tot = 0, len = 0;
            while (j < i + n && Math.abs(turn(j % n)) > 0.04 && len < 0.09){ tot += turn(j % n); if (j > i) len += seg[(j - 1) % n]; j++; }
            if (Math.abs(tot) > 0.75){
              // point médian de l'arc
              var mid = Math.floor((i + j - 1) / 2) % n, pm = c[mid];
              if ((j - 1 - i) % 2 === 1){ var q2 = c[(mid + 1) % n]; pm = [(pm[0] + q2[0]) / 2, (pm[1] + q2[1]) / 2]; }
              l.corners.push({p: pm, n1: nrm[(i - 1 + n) % n], n2: nrm[(j - 1) % n]});
            }
            i = Math.max(j, i + 1);
          } else i++;
        }
      });
    });
    var self = {W: W, H: 1, letters: L};
    // dessin : ox, oy, s = position et taille (px CSS par unité), v = profondeur (unités), prog 0..1 (apparition)
    self.draw = function(ox, oy, s, v, w, prog, dpr){
      prog = prog == null ? 1 : prog;
      var cw = canvas.width, ch = canvas.height;
      ctx.setTransform(1, 0, 0, 1, 0, 0); ctx.clearRect(0, 0, cw, ch);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      ctx.lineJoin = 'round'; ctx.lineCap = 'round'; ctx.strokeStyle = red; ctx.fillStyle = red;
      function P(q){ return [ox + q[0] * s, oy + q[1] * s]; }
      var pOut = Math.min(1, prog / .42), pDep = Math.max(0, Math.min(1, (prog - .36) / .4)), pHat = Math.max(0, (prog - .52) / .48);
      var e = 1 - Math.pow(1 - pDep, 3), vx = v[0] * e, vy = v[1] * e, vl = Math.hypot(vx, vy) || 1e-9;
      // 1 · silhouette du volume (contour extérieur)
      if (e > 0.001){
        var paths = L.map(function(l){
          var p = new Path2D();
          l.cs.forEach(function(c){
            var n = c.length, i, a, b;
            p.moveTo.apply(p, P(c[0])); for (i = 1; i < n; i++) p.lineTo.apply(p, P(c[i])); p.closePath();
            p.moveTo.apply(p, P([c[0][0] + vx, c[0][1] + vy])); for (i = 1; i < n; i++) p.lineTo.apply(p, P([c[i][0] + vx, c[i][1] + vy])); p.closePath();
            for (i = 0; i < n; i++){
              a = c[i]; b = c[(i + 1) % n];
              var q = [a, b, [b[0] + vx, b[1] + vy], [a[0] + vx, a[1] + vy]];
              if ((b[0] - a[0]) * vy - (b[1] - a[1]) * vx < 0) q.reverse();
              p.moveTo.apply(p, P(q[0])); p.lineTo.apply(p, P(q[1])); p.lineTo.apply(p, P(q[2])); p.lineTo.apply(p, P(q[3])); p.closePath();
            }
          });
          return p;
        });
        ctx.lineWidth = w * 2;
        paths.forEach(function(p){ ctx.stroke(p); ctx.fill(p); });
        ctx.globalCompositeOperation = 'destination-out';
        paths.forEach(function(p){ ctx.fill(p); });
        ctx.globalCompositeOperation = 'source-over';
      }
      // 2 · hachures des faces visibles, puis arêtes
      if (pHat > 0 && e > 0.02){
        ctx.lineWidth = Math.max(0.6, w * 0.42);
        L.forEach(function(l){
          l.samples.forEach(function(sm){
            var f = (sm.n[0] * vx + sm.n[1] * vy) / vl; if (f <= 0.02) return;
            var g = Math.max(0, Math.min(1, (pHat - sm.d * .55) / .45)); if (g <= 0) return;
            var a = Math.min(1, f / .3) * sm.al * g;
            var p0 = P([sm.p[0] + vx * sm.j0, sm.p[1] + vy * sm.j0]), k = sm.j0 + (1 - sm.j0 - sm.j1) * g;
            var p1 = P([sm.p[0] + vx * k, sm.p[1] + vy * k]);
            ctx.globalAlpha = a; ctx.beginPath(); ctx.moveTo(p0[0], p0[1]); ctx.lineTo(p1[0], p1[1]); ctx.stroke();
          });
        });
        ctx.globalAlpha = 1;
      }
      if (e > 0.02){
        ctx.lineWidth = w * .9;
        L.forEach(function(l){
          l.corners.forEach(function(cn){
            var f1 = cn.n1[0] * vx + cn.n1[1] * vy, f2 = cn.n2[0] * vx + cn.n2[1] * vy;
            if (f1 <= 0 || f2 <= 0) return;
            ctx.globalAlpha = Math.min(1, Math.min(f1, f2) / vl / .25);
            var a = P(cn.p), b = P([cn.p[0] + vx, cn.p[1] + vy]);
            ctx.beginPath(); ctx.moveTo(a[0], a[1]); ctx.lineTo(b[0], b[1]); ctx.stroke();
          });
        });
        ctx.globalAlpha = 1;
      }
      // 3 · faces avant : trait (dessiné au fil de l'apparition), intérieur vidé
      ctx.lineWidth = w * 2;
      L.forEach(function(l){
        var face = new Path2D();
        l.cs.forEach(function(c, ci){
          var p = new Path2D(); p.moveTo.apply(p, P(c[0])); for (var i = 1; i < c.length; i++) p.lineTo.apply(p, P(c[i])); p.closePath();
          face.addPath(p);
          if (pOut < 1){ var per = l.len[ci] * s; ctx.setLineDash([per * pOut, per + 10]); }
          ctx.stroke(p); ctx.setLineDash([]);
        });
        // la face avant (creux compris) est vidée d'un seul tenant : le creux reste visible
        ctx.globalCompositeOperation = 'destination-out'; ctx.fill(face); ctx.globalCompositeOperation = 'source-over';
      });
    };
    return self;
  }
  /* Palmiers de Californie (Washingtonia : tronc très fin, couronne en éventails, jupe de palmes sèches),
     dessinés au trait rouge comme le LENS. Une scène = liste de traits {pts, w, d (délai d'apparition 0..1)}. */
  function Palms(canvas, o){
    o = o || {};
    var ctx = canvas.getContext('2d'), red = o.color || '#DF0036';
    function rnd(s){ s = Math.sin(s * 91.37 + 17.13) * 43758.5453; return s - Math.floor(s); }
    function qpt(a, c, b, t){ var m = 1 - t; return [m * m * a[0] + 2 * m * t * c[0] + t * t * b[0], m * m * a[1] + 2 * m * t * c[1] + t * t * b[1]]; }
    function qtan(a, c, b, t){ var x = 2 * (1 - t) * (c[0] - a[0]) + 2 * t * (b[0] - c[0]), y = 2 * (1 - t) * (c[1] - a[1]) + 2 * t * (b[1] - c[1]), l = Math.hypot(x, y) || 1; return [x / l, y / l]; }
    function curve(a, c, b, n){ var r = []; for (var i = 0; i <= n; i++) r.push(qpt(a, c, b, i / n)); return r; }
    function build(p, seed){
      var S = [], B = p.base, T = p.top, C = p.ctrl, U = p.unit, k = 0;
      function R(){ return rnd(seed * 3.1 + (k++) * 1.618); }
      // tronc : deux traits fins, légèrement irréguliers
      var n = 60, L = [], Rr = [], mid = [];
      for (var i = 0; i <= n; i++){
        var t = i / n, c = qpt(B, C, T, t), tg = qtan(B, C, T, t), nm = [-tg[1], tg[0]];
        var w = U * (0.062 - 0.024 * t) * (1 + 0.05 * Math.sin(t * 23 + seed));
        L.push([c[0] + nm[0] * w, c[1] + nm[1] * w]); Rr.push([c[0] - nm[0] * w, c[1] - nm[1] * w]); mid.push({c: c, nm: nm, w: w, tg: tg});
      }
      S.push({pts: L, w: 1, d: 0}); S.push({pts: Rr, w: 1, d: 0.01});
      // anneaux (petits arcs) et ombre côté p.shade
      var t2 = 0.03;
      while (t2 < 0.9){
        var m = mid[Math.round(t2 * n)], ring = [], sag = m.w * 0.5;
        for (var j = 0; j <= 6; j++){ var u = -0.9 + 1.8 * j / 6, f = 1 - u * u; ring.push([m.c[0] + m.nm[0] * m.w * u - m.tg[0] * sag * f, m.c[1] + m.nm[1] * m.w * u - m.tg[1] * sag * f]); }
        S.push({pts: ring, w: .5, d: 0.04 + t2 * 0.3});
        var a1 = mid[Math.min(n, Math.round((t2 + 0.02) * n))], uu = p.shade * 0.55;
        S.push({pts: [[m.c[0] + m.nm[0] * m.w * uu, m.c[1] + m.nm[1] * m.w * uu], [a1.c[0] + a1.nm[0] * a1.w * uu, a1.c[1] + a1.nm[1] * a1.w * uu]], w: .45, d: 0.06 + t2 * 0.3});
        t2 += 0.034 + 0.012 * R();
      }
      // couronne : palmes en feuilles pointues (remplies de blanc pour masquer ce qui est derrière),
      // nervure centrale, hachures côté ombre et bord dentelé
      var fr = p.fronds || [[-150,.95],[-118,.7],[-90,.55],[-62,.72],[-30,.98],[-178,1.05],[-2,1.08],[160,.8],[22,.82]];
      // une palme qui toucherait un texte, le mot ou une carte est raccourcie (ou retirée)
      var avoid = p.avoid || [];
      function hits(pts){
        for (var i = 0; i < pts.length; i += 2){ var q = pts[i];
          for (var r = 0; r < avoid.length; r++){ var A = avoid[r]; if (q[0] > A[0] && q[0] < A[2] && q[1] > A[1] && q[1] < A[3]) return true; } }
        return false;
      }
      fr.forEach(function(f, fi){
        for (var sc = 1; sc >= 0.35; sc -= 0.13){
          var out = frond(f, fi, sc);
          if (!hits(out.pts)){ out.strokes.forEach(function(x){ S.push(x); }); return; }
        }
      });
      function frond(f, fi, sc){
        var S = [], all = [];
        var ang = f[0] * Math.PI / 180, L2 = U * f[1] * sc, dir = [Math.cos(ang), Math.sin(ang)], hz = Math.abs(dir[0]);
        var E = [T[0] + dir[0] * L2, T[1] + dir[1] * L2 + L2 * (0.18 + 0.42 * hz * hz)];
        var Cc = [T[0] + dir[0] * L2 * 0.55, T[1] + dir[1] * L2 * 0.55 - L2 * (0.18 + 0.1 * hz)];
        var N = 44, up = [], dn = [], spine = [];
        for (var i3 = 0; i3 <= N; i3++){
          var tt = i3 / N, pt = qpt(T, Cc, E, tt), tg = qtan(T, Cc, E, tt), nm = [-tg[1], tg[0]];
          if (nm[1] < 0) nm = [-nm[0], -nm[1]];                 // nm pointe vers le bas (côté ombre)
          var wd = U * 0.088 * Math.pow(Math.sin(Math.PI * Math.min(1, tt * 1.05)), 0.75) * (1 - 0.25 * tt);
          // dentelure : pointes des folioles inclinées vers l'extrémité de la palme
          var tooth = i3 % 2 ? 1 : 0.72, fw = i3 % 2 ? wd * 0.35 : 0;
          spine.push(pt);
          up.push([pt[0] - nm[0] * wd * tooth + tg[0] * fw, pt[1] - nm[1] * wd * tooth + tg[1] * fw]);
          dn.push([pt[0] + nm[0] * wd * tooth + tg[0] * fw, pt[1] + nm[1] * wd * tooth + tg[1] * fw]);
        }
        var outline = up.concat(dn.slice().reverse());
        var d0 = 0.42 + 0.03 * fi;
        S.push({pts: outline, w: .9, d: d0, fill: true});
        S.push({pts: spine.slice(0, N - 1), w: .55, d: d0 + .04});
        // hachures : de la nervure vers le bord bas, inclinées vers la pointe
        for (var h3 = 4; h3 < N - 3; h3 += 3){
          var a0 = spine[h3], b0 = dn[Math.min(N, h3 + 3)];
          S.push({pts: [[a0[0] + (b0[0] - a0[0]) * .12, a0[1] + (b0[1] - a0[1]) * .12], [a0[0] + (b0[0] - a0[0]) * .9, a0[1] + (b0[1] - a0[1]) * .9]], w: .42, d: d0 + .08 + h3 / N * .1});
        }
        S.forEach(function(x){ all = all.concat(x.pts); });
        return {strokes: S, pts: all};
      }
      return S;
    }
    var scenes = [];
    return {
      set: function(list){ scenes = list.map(function(p, i){ return build(p, (i + 1) * 13.7); }); },
      draw: function(dpr, w, prog, ox, oy){
        prog = prog == null ? 1 : prog;
        ctx.setTransform(1, 0, 0, 1, 0, 0); ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.setTransform(dpr, 0, 0, dpr, (ox || 0) * dpr, (oy || 0) * dpr);
        ctx.strokeStyle = red; ctx.lineCap = 'round'; ctx.lineJoin = 'round';
        scenes.forEach(function(S){
          S.forEach(function(st){
            var g = Math.max(0, Math.min(1, (prog - st.d * 0.8) / 0.2)); if (g <= 0) return;
            var pts = st.pts, nn = Math.max(1, Math.round((pts.length - 1) * g));
            ctx.lineWidth = Math.max(0.5, w * st.w); ctx.globalAlpha = st.w < .5 ? .85 : 1;
            ctx.beginPath(); ctx.moveTo(pts[0][0], pts[0][1]);
            if (st.fill){
              for (var i = 1; i < pts.length; i++) ctx.lineTo(pts[i][0], pts[i][1]);
              ctx.closePath();
              ctx.save(); ctx.globalAlpha = Math.min(1, g * 1.4); ctx.globalCompositeOperation = 'destination-out'; ctx.fill(); ctx.restore();
              ctx.beginPath(); ctx.moveTo(pts[0][0], pts[0][1]);
            }
            for (var i = 1; i <= nn; i++) ctx.lineTo(pts[i][0], pts[i][1]);
            if (st.fill && g >= 1) ctx.closePath();
            ctx.stroke();
          });
        });
        ctx.globalAlpha = 1;
      }
    };
  }
  var hero = document.querySelector('[data-hero]');
  if (hero){
    var hIn = hero.querySelector('.lx-in'), wbox = hero.querySelector('.lx-wordbox'), cv = hero.querySelector('.lx-word');
    var girl = hero.querySelector('.lx-subj'), hdm = hero.querySelector('.lx-damier');
    // hauteur disponible : tout l'écran sous l'en-tête (bandeau compris)
    function top0(){ hero.style.setProperty('--top0', Math.round(hero.getBoundingClientRect().top + window.scrollY) + 'px'); }
    top0();
    var W3 = null, dpr = 1, prog = reduce ? 1 : 0, started = false;
    try { if (cv.getContext && cv.getContext('2d')) W3 = Word3D(cv, GLYPHS, {track:.06, color:'#DF0036'}); } catch(e){ W3 = null; }
    if (!W3) hero.querySelector('.lx-word-fb').style.display = 'block';
    var V0 = [.065, .12], hx = 0, hy = 0, gx = 0, gy = 0, hsp = 0, hRun = false, hVis = true;
    // palmiers dessinés : ils sortent des bords de l'écran, dans les coins laissés libres par le texte
    var pcv = hero.querySelector('.lx-palms'), PL = null, pW = 1.4, palmsOn = true;
    var wideQ = window.matchMedia('(min-width: 1024px) and (min-aspect-ratio: 1/1)');
    try { if (pcv && pcv.getContext && pcv.getContext('2d')) PL = Palms(pcv, {color:'#DF0036'}); } catch(e){ PL = null; }
    function layoutPalms(){
      if (!PL || !wideQ.matches) return;
      if (!palmsOn){ return; }
      var r = pcv.getBoundingClientRect(), d = Math.min(2, window.devicePixelRatio || 1);
      pcv.width = Math.max(1, Math.round(r.width * d)); pcv.height = Math.max(1, Math.round(r.height * d));
      var inR = hIn.getBoundingClientRect(), pad = parseFloat(getComputedStyle(hIn).paddingLeft) || 0;
      var cL = inR.left + pad, cR = inR.right - pad;
      // assez de marge pour qu'on lise un palmier, pas un fragment
      var tg = document.querySelector('[data-palms-toggle]'); if (tg) tg.hidden = cL < 90;
      pcv.style.visibility = cL < 90 ? 'hidden' : ''; if (cL < 90) return;
      var eb = hero.querySelector('.lx-l .eyebrow').getBoundingClientRect(), crd = hero.querySelector('.lx-r').getBoundingClientRect();
      var top = hero.getBoundingClientRect().top, dmT = hdm.getBoundingClientRect().top;
      function U0(room){ return Math.max(120, Math.min(300, Math.min(cL * 1.6, (room - 10) / 1.05))); }
      var Ul = U0(eb.top - top), Ur = U0(crd.top - top);
      var Tl = [cL - Ul * .55, eb.top - Ul * .7 - 8], Tr = [cR + Ur * .55, crd.top - Ur * .7 - 8];
      var ox = r.left, oy = r.top, avoid = [];
      function add(b, m){ avoid.push([b.left - ox - m, b.top - oy - m, b.right - ox + m, b.bottom - oy + m]); }
      var ol = hero.querySelector('.lx .crumbs ol'), li = ol.lastElementChild.getBoundingClientRect(), ob = ol.getBoundingClientRect();
      add({left: ob.left, top: ob.top, right: li.right, bottom: ob.bottom}, 12);
      [].forEach.call(hero.querySelectorAll('.lx-l > :not(.sr)'), function(e){ add(e.getBoundingClientRect(), 12); });
      add(crd, 12);
      var wb = wbox.getBoundingClientRect(), cap = wb.height;
      add({left: wb.left, top: wb.top, right: wb.right + cap * .2, bottom: wb.bottom + cap * .22}, 14);
      PL.set([
        {base:[Tl[0] + Ul * .38 - ox, dmT + 12 - oy], top:[Tl[0] - ox, Tl[1] - oy], ctrl:[Tl[0] + Ul * .42 - ox, (Tl[1] + dmT) / 2 - oy], unit:Ul, shade:1, avoid:avoid,
         fronds:[[-150,.95],[-118,.7],[-92,.55],[-64,.6],[-36,.8],[-178,1.05],[-6,1.04],[160,.8],[24,.82]]},
        {base:[Tr[0] - Ur * .38 - ox, dmT + 12 - oy], top:[Tr[0] - ox, Tr[1] - oy], ctrl:[Tr[0] - Ur * .42 - ox, (Tr[1] + dmT) / 2 - oy], unit:Ur, shade:-1, avoid:avoid,
         fronds:[[-30,.95],[-62,.7],[-88,.55],[-116,.6],[-144,.8],[-2,1.05],[-174,1.04],[20,.8],[156,.82]]}
      ]);
      pW = Math.max(1.1, Math.min(1.7, (Ul + Ur) / 2 * .0085)); pDpr = d;
      drawPalms();
    }
    var pDpr = 1, lastPP = -1;
    function drawPalms(){ if (PL && wideQ.matches && palmsOn) PL.draw(pDpr, pW, Math.max(0, Math.min(1, (prog - .3) / .7))); }
    function sizeCanvas(){
      if (!W3) return;
      dpr = Math.min(2, window.devicePixelRatio || 1);
      var r = cv.getBoundingClientRect();
      cv.width = Math.max(1, Math.round(r.width * dpr)); cv.height = Math.max(1, Math.round(r.height * dpr));
      drawWord();
    }
    function drawWord(){
      if (!W3) return;
      var rb = wbox.getBoundingClientRect(), rc = cv.getBoundingClientRect();
      var s = rb.width / W3.W;
      W3.draw(rb.left - rc.left, rb.top - rc.top, s, [V0[0] + gx * .085, V0[1] + gy * .045 + hsp * .06], Math.max(1.15, s * .0108), prog, dpr);
    }
    function heroFrame(){
      var r = hero.getBoundingClientRect();
      hsp = Math.max(0, Math.min(1, -r.top / Math.max(1, r.height)));
      if (!reduce){
        wbox.style.transform = 'translate3d(' + (-gx * 7).toFixed(1) + 'px,' + (-gy * 5 - hsp * 40).toFixed(1) + 'px,0)';
        girl.style.transform = 'translate3d(' + (-gx * 16).toFixed(1) + 'px,' + (gy * 7 + hsp * 60).toFixed(1) + 'px,0)';
        hdm.style.backgroundPositionX = (-window.scrollY * .6 - gx * 10).toFixed(1) + 'px';
        if (pcv) pcv.style.transform = 'translate3d(' + (-gx * 10).toFixed(1) + 'px,' + (-gy * 6 + hsp * 30).toFixed(1) + 'px,0)';
      }
      drawWord();
      if (prog !== lastPP){ lastPP = prog; drawPalms(); }
    }
    function hTick(){
      gx += (hx - gx) * .08; gy += (hy - gy) * .08;
      heroFrame();
      if (Math.abs(hx - gx) > .002 || Math.abs(hy - gy) > .002){ requestAnimationFrame(hTick); } else { hRun = false; }
    }
    function hKick(){ if (!hRun && hVis && started){ hRun = true; requestAnimationFrame(hTick); } }
    // apparition : le mot se dessine, la supportrice sort du damier
    function intro(){
      if (started) return; started = true;
      hero.classList.remove('wait'); hero.classList.add('ready');
      if (reduce || document.visibilityState === 'hidden'){ prog = 1; heroFrame(); return; }
      var t0 = performance.now(), D = 2000;
      (function step(now){
        prog = Math.min(1, (now - t0) / D); heroFrame();
        if (prog < 1) requestAnimationFrame(step);
      })(t0);
    }
    var gDone = false;
    function gReady(){ if (gDone) return; gDone = true; intro(); }
    function gLoaded(){ if (girl.decode){ girl.decode().then(gReady, gReady); setTimeout(gReady, 700); } else gReady(); }
    // image ratée (réseau, fichier pas encore disponible) : un second essai sans cache, puis jamais d'icône d'erreur
    var gTry = 0;
    girl.addEventListener('error', function(){
      if (gTry++ < 1){ var b = '?r=' + Date.now(); girl.srcset = girl.srcset.replace(/\.webp(?=\s)/g, '.webp' + b); girl.src = girl.src.split('?')[0] + b; return; }
      hero.classList.add('g-err'); gReady();
    });
    girl.addEventListener('load', function(){ hero.classList.remove('g-err'); if (gDone) return; gLoaded(); });
    if (girl.complete && girl.naturalWidth) gLoaded();
    else if (girl.complete && !girl.naturalWidth && girl.currentSrc) girl.dispatchEvent(new Event('error'));
    setTimeout(gReady, 3500);
    sizeCanvas(); layoutPalms();
    window.addEventListener('resize', function(){ top0(); sizeCanvas(); layoutPalms(); heroFrame(); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function(){ top0(); sizeCanvas(); layoutPalms(); });
    // prototype : comparer avec et sans palmiers
    var pt = document.querySelector('[data-palms-toggle]');
    if (pt) pt.addEventListener('click', function(){
      palmsOn = !palmsOn; hero.classList.toggle('no-palms', !palmsOn);
      pt.setAttribute('aria-pressed', palmsOn); pt.textContent = 'Palmiers : ' + (palmsOn ? 'oui' : 'non');
      if (palmsOn) layoutPalms();
    });
    inView(hero, function(v){ hVis = v; if (v) hKick(); });
    if (!reduce){
      window.addEventListener('pointermove', function(e){
        if (!fine.matches) return;
        hx = Math.max(-1, Math.min(1, (e.clientX / window.innerWidth) * 2 - 1));
        hy = Math.max(-1, Math.min(1, (e.clientY / window.innerHeight) * 2 - 1));
        hKick();
      }, {passive:true});
      window.addEventListener('scroll', function(){ if (hVis && started) { if (!hRun) heroFrame(); } }, {passive:true});
    }
  }

  /* ---- La carte : la photo du produit suit la souris au survol (ordinateur) ---- */
  var board = document.querySelector('[data-board]'), peek = document.querySelector('.bd-peek');
  if (board && peek && !reduce){
    var pim = peek.firstChild, px = 0, py = 0, qx = 0, qy = 0, pOn = false, pRun = false;
    [].forEach.call(board.querySelectorAll('li[data-img]'), function(li){
      li.addEventListener('pointerenter', function(e){
        if (e.pointerType !== 'mouse') return;
        pim.src = window.WF_ASSETS + li.dataset.img + '.webp' + (window.WF_V || ''); pOn = true; peek.classList.add('on');
        if (!pRun){ qx = e.clientX; qy = e.clientY; }
        go();
      });
      li.addEventListener('pointerleave', function(){ pOn = false; peek.classList.remove('on'); });
    });
    board.addEventListener('pointermove', function(e){ px = e.clientX; py = e.clientY; if (pOn) go(); }, {passive:true});
    window.addEventListener('scroll', function(){ if (pOn){ pOn = false; peek.classList.remove('on'); } }, {passive:true});
    function go(){ if (!pRun){ pRun = true; requestAnimationFrame(step); } }
    function step(){
      qx += (px - qx) * .18; qy += (py - qy) * .18;
      var w = peek.offsetWidth, x = qx + 28, y = qy - w / 2;
      if (x + w > window.innerWidth - 12) x = qx - w - 28;
      var rot = Math.max(-8, Math.min(8, (px - qx) * .12));
      peek.style.transform = 'translate3d(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px,0) rotate(' + rot.toFixed(2) + 'deg)';
      if (pOn && (Math.abs(px - qx) > .3 || Math.abs(py - qy) > .3)){ requestAnimationFrame(step); } else { pRun = false; }
    }
  }

  /* ---- La carte sur mobile : une catégorie à la fois ---- */
  var tabs = document.querySelector('.bd-tabs');
  if (tabs && board){
    tabs.addEventListener('click', function(e){
      var b = e.target.closest('button[data-cat]'); if (!b) return;
      board.dataset.cat = b.dataset.cat;
      [].forEach.call(tabs.querySelectorAll('button'), function(x){ x.setAttribute('aria-selected', String(x === b)); });
    });
  }

  /* ---- Plan : les trajets se dessinent à l'arrivée ; survol d'un repère = trajet surligné ---- */
  var map = document.querySelector('[data-map]');
  if (map){
    inView(map, function(v){ if (v) map.classList.add('in'); }, {threshold:.35});
    function hi(n, on){
      map.classList.toggle('hi-' + n, on);
      var g = map.querySelector('.mark[data-mark="' + n + '"]'); if (g) g.classList.toggle('hi', on);
      var li = document.querySelector('.marks li[data-mark="' + n + '"]'); if (li) li.classList.toggle('hi', on);
    }
    [].forEach.call(document.querySelectorAll('[data-mark]'), function(el){
      var n = el.dataset.mark;
      el.addEventListener('pointerenter', function(){ hi(n, true); });
      el.addEventListener('pointerleave', function(){ hi(n, false); });
    });
  }

  /* ---- Le lieu : défilement horizontal piloté par le scroll vertical (ordinateur) ---- */
  var zp = document.querySelector('[data-zones]');
  if (zp){
    var zvp = zp.querySelector('[data-zones-viewport]'), ztr = zp.querySelector('[data-zones-track]'), zbar = zp.querySelector('[data-zones-bar]');
    var zimgs = [].slice.call(ztr.querySelectorAll('figure img')), zmax = 0;
    function zlayout(){
      if (desk.matches && !reduce){
        zp.classList.add('pinned');
        var st = zp.querySelector('.zones-sticky'), cs = getComputedStyle(zvp);
        zmax = Math.max(0, ztr.scrollWidth - (zvp.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight)));
        zp.style.height = (st.offsetHeight + zmax) + 'px';
      } else { zp.classList.remove('pinned'); zp.style.height = ''; ztr.style.transform = ''; zmax = 0; zimgs.forEach(function(im){ im.style.transform = ''; }); }
      zscroll();
    }
    function zscroll(){
      var p;
      if (zp.classList.contains('pinned')){
        var r = zp.getBoundingClientRect(), total = zp.offsetHeight - zp.querySelector('.zones-sticky').offsetHeight;
        p = total > 0 ? Math.min(1, Math.max(0, (hdrH() - r.top) / total)) : 0;
        ztr.style.transform = 'translate3d(' + (-p * zmax).toFixed(1) + 'px,0,0)';
        // la photo glisse moins vite que sa carte : effet de profondeur
        var vw = window.innerWidth;
        zimgs.forEach(function(im){ var b = im.parentNode.getBoundingClientRect(); var c = (b.left + b.width / 2) / vw - .5; im.style.transform = 'translate3d(' + (-c * 9).toFixed(2) + '%,0,0)'; });
      } else { var m = zvp.scrollWidth - zvp.clientWidth; p = m > 0 ? zvp.scrollLeft / m : 0; }
      if (zbar) zbar.style.width = (12 + p * 88).toFixed(1) + '%';
    }
    var zt = false;
    window.addEventListener('scroll', function(){ if (!zt){ zt = true; requestAnimationFrame(function(){ zscroll(); zt = false; }); } }, {passive:true});
    zvp.addEventListener('scroll', zscroll, {passive:true});
    window.addEventListener('resize', zlayout);
    zimgs.forEach(function(im){ if (!im.complete) im.addEventListener('load', zlayout, {once:true}); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(zlayout);
    zlayout();
  }

  /* ---- Envie de quoi ? : les produits apparaissent sous la souris (ou le doigt) ---- */
  var ts = document.querySelector('[data-trail]');
  if (ts && !reduce){
    var SRC = ['smash-burger-the-1976-woodys-factory','milkshake-the-real-shake-creme-glacee-woodys-factory','frites-wavy-fries-woodys-factory','cookie-kinder-maison-woodys-factory','smash-burger-the-trucker-bacon-woodys-factory','soda-signature-sprite-violette-woodys-factory','smash-burger-the-golden-goat-chevre-woodys-factory','frites-cheddar-fries-woodys-factory','cookie-dough-pate-a-cookie-woodys-factory','smash-burger-the-redwood-woodys-factory','onion-rings-woodys-factory','milkshake-cafe-the-coffee-shake-woodys-factory','burger-the-melt-brioche-woodys-factory','soda-signature-coca-cola-mangue-woodys-factory','cookie-chocolat-blanc-macadamia-woodys-factory','mac-and-cheese-balls-woodys-factory'];
    var pool = [], idx = 0, lx = null, ly = null, auto = 0, lastUser = 0, tv = false;
    for (var i = 0; i < 14; i++){
      var n = document.createElement('span'); n.className = 'trail-img'; n.setAttribute('aria-hidden', 'true'); n.style.opacity = '0';
      var im = document.createElement('img'); im.alt = ''; im.decoding = 'async'; n.appendChild(im); ts.appendChild(n); pool.push(n);
    }
    function spawn(x, y, speed){
      var n = pool[idx % pool.length], im = n.firstChild; idx++;
      var name = SRC[idx % SRC.length]; im.src = window.WF_ASSETS + name + '.webp' + (window.WF_V || '');
      var w = n.offsetWidth || 160, rot = (Math.random() * 16 - 8).toFixed(1), sc = Math.min(1.15, .8 + speed * .012);
      n.getAnimations && n.getAnimations().forEach(function(a){ a.cancel(); });
      n.style.zIndex = String(10 + idx % 500);
      var from = 'translate(' + (x - w / 2) + 'px,' + (y - w / 2) + 'px)';
      n.animate([
        {transform: from + ' scale(.3) rotate(' + rot + 'deg)', opacity:0},
        {transform: from + ' scale(' + sc + ') rotate(' + rot + 'deg)', opacity:1, offset:.22},
        {transform: from + ' scale(' + sc + ') rotate(' + rot + 'deg)', opacity:1, offset:.6},
        {transform: 'translate(' + (x - w / 2) + 'px,' + (y - w / 2 + 40) + 'px) scale(.5) rotate(' + (-rot) + 'deg)', opacity:0}
      ], {duration:1500, easing:'cubic-bezier(.16,1,.3,1)', fill:'forwards'});
    }
    function at(cx, cy, fromUser){
      var r = ts.getBoundingClientRect(), x = cx - r.left, y = cy - r.top;
      if (lx === null){ lx = x; ly = y; return; }
      var d = Math.hypot(x - lx, y - ly);
      if (d > 90){ spawn(x, y, d); lx = x; ly = y; }
      if (fromUser){ lastUser = Date.now(); var h = ts.querySelector('[data-trail-hint]'); if (h) h.style.opacity = '0'; }
    }
    ts.addEventListener('pointermove', function(e){ at(e.clientX, e.clientY, true); }, {passive:true});
    ts.addEventListener('pointerleave', function(){ lx = null; });
    var hint = ts.querySelector('[data-trail-hint]'); if (hint && !fine.matches) hint.textContent = 'Glissez le doigt.';
    // démonstration automatique quand la section arrive et que personne ne bouge
    function demo(){
      if (!tv || Date.now() - lastUser < 2500) return;
      var r = ts.getBoundingClientRect(), t0 = performance.now(); lx = null;
      (function step(t){
        var k = (t - t0) / 2600; if (k > 1 || Date.now() - lastUser < 500){ lx = null; return; }
        var a = k * Math.PI * 2;
        at(r.left + r.width * (.5 + .36 * Math.sin(a)), r.top + r.height * (.5 + .26 * Math.sin(2 * a)), false);
        requestAnimationFrame(step);
      })(t0);
    }
    inView(ts, function(v){ tv = v; if (v){ clearInterval(auto); setTimeout(demo, 500); auto = setInterval(demo, fine.matches ? 9000 : 6000); } else { clearInterval(auto); } }, {threshold:.45});
  }
})();


/* Encart Miami : « Miami » s'allume et les stickers se posent à l'arrivée ; compte à rebours et libellés (heure de Paris) ;
   retrait après le 30/11. Mouvement réduit respecté. */
(function(){
  var me = document.querySelector('[data-me]'); if (!me) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var START = Date.parse('2026-11-02T11:30:00+01:00'), END = Date.parse('2026-11-30T23:59:59+01:00');
  var k = me.querySelector('[data-me-k]'), ck = me.querySelector('[data-me-ck]'), cnt = me.querySelector('[data-me-count]'), U = {};
  if (cnt) cnt.querySelectorAll('[data-u]').forEach(function(u){ U[u.getAttribute('data-u')] = u; });
  var two = function(n){ return (n < 10 ? '0' : '') + n; };
  var tick = function(){
    var now = Date.now();
    if (now > END){ me.hidden = true; return; }
    var pre = now < START, s = Math.floor(((pre ? START : END) - now) / 1000);
    if (k) k.textContent = pre ? '[\xa0Édition limitée · dès lundi 2 novembre\xa0]' : "[\xa0Édition limitée · jusqu'au 30 novembre\xa0]";
    if (ck) ck.textContent = pre ? '[\xa0Début du jeu dans\xa0]' : '[\xa0Fin du jeu dans\xa0]';
    if (U.d) U.d.textContent = Math.floor(s / 86400);
    if (U.h) U.h.textContent = two(Math.floor(s % 86400 / 3600));
    if (U.m) U.m.textContent = two(Math.floor(s % 3600 / 60));
  };
  tick(); setInterval(tick, 30000);
  if (!reduce && 'IntersectionObserver' in window){
    me.classList.add('is-armed');
    var io = new IntersectionObserver(function(es){ es.forEach(function(e){ if (e.isIntersecting){ me.classList.add('is-in'); io.disconnect(); } }); }, {threshold: .3});
    io.observe(me);
  }
})();
